import { Link } from "react-router-dom";
import { Instagram, Facebook, Youtube } from "lucide-react";
import { TikTokIcon } from "@/components/icons";

const SOCIALS = [
  { href: "https://www.instagram.com/yesamen.app/", label: "Instagram", Icon: Instagram, testId: "footer-social-instagram" },
  { href: "https://www.facebook.com/yesamenapp/", label: "Facebook", Icon: Facebook, testId: "footer-social-facebook" },
  { href: "https://www.youtube.com/@yesamenapp", label: "YouTube", Icon: Youtube, testId: "footer-social-youtube" },
  { href: "https://www.tiktok.com/@yesamen.app", label: "TikTok", Icon: TikTokIcon, testId: "footer-social-tiktok" },
];

export const Footer = () => (
  <footer data-testid="footer-section" className="relative overflow-hidden bg-[#0B1320]">
    <img
      src="/assets/footer-mountains.webp"
      alt=""
      loading="lazy"
      className="absolute inset-0 h-full w-full object-cover opacity-50"
    />
    <div className="absolute inset-0 bg-[#0B1320]/55" />

    <div className="relative mx-auto max-w-7xl px-6 py-20 lg:px-10 lg:py-24">
      <div className="flex flex-col gap-12 md:flex-row md:items-end md:justify-between">
        <div>
          <p data-testid="footer-logo" className="font-serif text-2xl tracking-[0.16em] text-white">
            YES &amp; AMEN
          </p>
          <p className="mt-4 text-[11px] font-medium uppercase tracking-[0.3em] text-white/45">
            Daily Bible Promises &amp; Prayer.
          </p>
        </div>

        <div className="flex flex-col gap-6 md:items-end">
          <div className="flex items-center gap-4">
            {SOCIALS.map(({ href, label, Icon, testId }) => (
              <a
                key={label}
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={label}
                data-testid={testId}
                className="flex h-10 w-10 items-center justify-center rounded-full border border-white/15 text-white/70 transition-[color,border-color,transform] duration-300 hover:-translate-y-0.5 hover:border-white/40 hover:text-white"
              >
                <Icon className="h-[17px] w-[17px]" strokeWidth={1.5} />
              </a>
            ))}
          </div>
          <nav className="flex items-center gap-8" aria-label="Footer">
            <Link
              to="/support"
              data-testid="footer-link-support"
              className="text-[11px] font-medium uppercase tracking-[0.28em] text-white/60 transition-colors duration-300 hover:text-white"
            >
              Support
            </Link>
            <Link
              to="/privacy"
              data-testid="footer-link-privacy"
              className="text-[11px] font-medium uppercase tracking-[0.28em] text-white/60 transition-colors duration-300 hover:text-white"
            >
              Privacy
            </Link>
          </nav>
        </div>
      </div>

      <div className="mt-14 border-t border-white/10 pt-8">
        <p className="text-[10px] font-medium uppercase tracking-[0.28em] text-white/35 md:text-right">
          © 2026 YES &amp; AMEN. All rights reserved.
        </p>
      </div>
    </div>
  </footer>
);
